const URI = '/forms';

export const getFormSchema = async formId => {
  var options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const getUrl = `${URI}/${formId}`;
  const schema = await request(getUrl, options);
  return schema;
};
export const getEntries = async (formObj, id) => {
  var options = {
    method: 'POST',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formObj),
  };
  const entriesUrl = `${URI}/entries`;
  const entries = await request(entriesUrl, options);

  return {
    entries,
    id,
  };
};
export const postForm = async formObj => {
  var options = {
    method: 'POST',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formObj),
  };
  const submitted = await request(URI, options);
  return submitted;
};
const request = async (url, options) => {
  return (
    fetch(url, options)
      .then(response => response.json())
      .then(result => {
        return result;
      })
      // eslint-disable-next-line no-console
      .catch(error => console.log('error', error))
  );
};
